<lms-breadcrumb [label]="'students.invite.title'"></lms-breadcrumb>
<lms-dynamic-form
  *ngIf="!clientId; else showTable"
  [title]="'students.invite.title'"
  [questions]="questions"
  [options]="{ submitLabel: 'wizard.nextButton', showSpinnerUponSubmitting: false }"
  (submit)="setClient($event)"
>
  <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="goBack()" form-actions-before>
  </gl-button>
</lms-dynamic-form>

<ng-template #showTable>
  <div class="margin-top margin-bottom">
    <lms-students-batch-create
      [tooltipText]="infoMessage"
      (studentsData)="addImportedStudents($event)"
    ></lms-students-batch-create>
  </div>
  <gl-button color-secondary [text]="'actions.cancel' | translate" (onClick)="goBack()" form-actions-before></gl-button>
</ng-template>
